export default __webpack_public_path__ + "static/media/211.33f4de01.jpg";